export enum TaxAffectsType {
  PhoneCardPurchase = 'Phone Card Purchase',
  DirectBillPaymentFees = 'DirectBill Payment Fees',
  WalletPaymentFees = 'Wallet Payment Fees',
  AudioVideoPaymentFees = 'AV Wallet Payment Fees'
}